import { Route, Switch, useRouteMatch } from "react-router-dom";
import DashboardHeader from "../../components/DashboardHeader/DashboardHeader";
import Footer from "../../components/Footer/Footer";
import Homepage from "./Homepage";
import Profilepage from "./Profilepage";

import { ViewGridAddIcon } from "@heroicons/react/outline";
import { useDispatch } from "react-redux";
import { createDiscussionSliceActions } from "../../redux/features/Modal/createDiscussionSlice";
import RoomDetail from "./RoomDetail";
import Recommended from "./Recommended";

const DashBoard = () => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();

  return (
    <div className="min-h-screen w-full bg-gray-100">
      <DashboardHeader />
      <Switch>
        <Route path={`${path}/profile/:userId`} component={Profilepage} />
        <Route path={`${path}/recommended`} component={Recommended} />
        <Route path={`${path}/discussioin/:roomId`} component={RoomDetail} />
        <Route exact path={`${path}`} component={Homepage} />
      </Switch>
      <div className="lg:hidden fixed bottom-0 w-full">
        <div className=" absolute right-0 mr-5 mb-5 bottom-16">
          <ViewGridAddIcon
            onClick={() => dispatch(createDiscussionSliceActions.enebleModal())}
            className="h-14 text-white rounded-full px-3 bg-green-800 py-3"
          />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DashBoard;
